import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankCriteria, getBlankRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },
  [mutation.STATE_UNLOAD_LISTING](state) {
    state.listing.loaded = false;
  },

  [mutation.LIST_TOGGLE_EXPAND](state, noticeId) {
    state.timeline.hasNotice(noticeId) ? state.timeline.removeNotice(noticeId) : state.timeline.addNotice(noticeId);
  },
  [mutation.LIST_SET_FILTERS](state, { levyCollectionId, providerId }) {
    state.listing.levyCollectionId = levyCollectionId;
    state.listing.providerId = providerId;
  },
  [mutation.LIST_SET_CRITERIA](state, searchCriteria) {
    stateMerge(state.listing.criteria, searchCriteria);
  },
  [mutation.LIST_CLEAR_CRITERIA](state) {
    stateMerge(state.listing.criteria, getBlankCriteria());
  },
  [mutation.LIST_SET_CRITERIA_DESCRIPTION](state, criteriaInfo) {
    state.listing.criteriaInfo = criteriaInfo;
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, results) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = results;
    state.listing.empty = results.length == 0 && !state.listing.criteriaInfo.hasCriteria;
  },

  [mutation.EXPORT_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_FAILED](state) {
    state.listing.loading = false;
  },

  [mutation.PREVIEW_SEND_STARTED](state) {
    state.previewSend.data = null;
    state.previewSend.loading = true;
  },
  [mutation.PREVIEW_SEND_SUCCEEDED](state, result) {
    state.previewSend.data = result;
    state.previewSend.loading = false;
  },
  [mutation.PREVIEW_SEND_FAILED](state) {
    state.previewSend.loading = false;
  },
  [mutation.PREVIEW_RESEND_STARTED](state) {
    state.previewResend.loading = true;
    state.previewResend.data = null;
  },
  [mutation.PREVIEW_RESEND_SUCCEEDED](state, result) {
    state.previewResend.data = result;
    state.previewResend.loading = false;
  },
  [mutation.PREVIEW_RESEND_FAILED](state) {
    state.previewResend.loading = false;
  },

  [mutation.SEND_STARTED](state) {
    state.send.loading = true;
  },
  [mutation.SEND_SUCCEEDED](state, result) {
    state.send.data = result;
    state.send.loading = false;
  },
  [mutation.SEND_FAILED](state) {
    state.send.loading = false;
  },

  [mutation.RESEND_SET_DATA](state, details) {
    stateMerge(state.resend.data, details);
  },
  [mutation.RESEND_STARTED](state) {
    state.resend.loading = true;
  },
  [mutation.RESEND_SUCCEEDED](state, result) {
    state.resend.data = result;
    state.resend.loading = false;
  },
  [mutation.RESEND_FAILED](state) {
    state.resend.loading = false;
  },

  [mutation.GET_TIMELINE_STARTED](state, { levyCollectionId, providerId }) {
    state.timeline.loading = true;
    state.timeline.loaded = false;
    state.timeline.levyCollectionId = levyCollectionId;
    state.timeline.providerId = providerId;
  },
  [mutation.GET_TIMELINE_SUCCEEDED](state, data) {
    state.timeline.loading = false;
    state.timeline.loaded = true;
    state.timeline.data = data;
  },
  [mutation.GET_TIMELINE_FAILED](state) {
    state.timeline.loading = false;
    state.timeline.loaded = false;
  },

  [mutation.VIEW_CLEAR](state) {
    state.view.loading = false;
    state.view.data = getBlankRecord();
  },
  [mutation.VIEW_STARTED](state) {
    state.view.loading = true;
  },
  [mutation.VIEW_SUCCEEDED](state, notice) {
    state.view.loading = false;
    stateMerge(state.view.data, notice);
  },
  [mutation.VIEW_FAILED](state) {
    state.view.loading = false;
  }
};
